/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ before: NonNullable<unknown>, after: NonNullable<unknown> }} Workout_After_Carry_SetsInputs */

const en_us2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sets: ${i?.before} → ${i?.after}`)
};

const pt_br2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries: ${i?.before} → ${i?.after}`)
};

const es_419_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Series: ${i?.before} → ${i?.after}`)
};

const pt_pt2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries: ${i?.before} → ${i?.after}`)
};

const fr_fr2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries : ${i?.before} → ${i?.after}`)
};

const de_de2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sätze: ${i?.before} → ${i?.after}`)
};

const it_it2_workout_after_carry_sets = /** @type {(inputs: Workout_After_Carry_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie: ${i?.before} → ${i?.after}`)
};

/**
* | output |
* | --- |
* | "Sets: {before} → {after}" |
*
* @param {Workout_After_Carry_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_sets = /** @type {((inputs: Workout_After_Carry_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_sets(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_sets(inputs)
	return en_us2_workout_after_carry_sets(inputs)
});
export { workout_after_carry_sets as "workout-after.carry_sets" }